import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import DateHelper from "../DateHelper/DateHelper";
import { subDays, isBefore } from "date-fns";

class PortalReservationCancel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      billing_policy: this.props.reservation_segment.billing_policy,
      cancelled: false,
      errors: null,
      success: null,
      reservation_segment: this.props.reservation_segment,
      loading: false,
    };

    this.onCancel = this.onCancel.bind(this);
  }

  render() {
    //console.log("PortalReservationCancel", this.props, this.state);

    return (
      <div className="PortalReservationCancel">
        {this.renderErrors()}
        {this.renderSuccess()}
        {this.state.cancelled ? null : this.renderForm()}
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  renderForm() {
    if (this.state.reservation_segment.status == "canceled") {
      return this.renderCannotCancel();
    } else {
      if (this.state.billing_policy.refundable) {
        var refundable_until_date = this.getRefundableUntilDate();
        if (isBefore(new Date(), refundable_until_date)) {
          return this.renderFullyRefundable();
        } else {
          return this.renderCannotCancel();
        }
      } else {
        if (
          this.props.active_cancellation_rule &&
          this.props.active_cancellation_rule.custom_rule !== ""
        ) {
          return this.renderConfirmation(
            this.props.active_cancellation_rule.custom_rule,
            I18n.t("cancel_this_room"),
            this.onCancel
          );
        } else if (this.props.active_cancellation_rule) {
          if (this.props.active_cancellation_rule.percentage) {
            var penalty =
              this.props.active_cancellation_rule.percentage * 100 + "%";
          } else if (this.props.active_cancellation_rule.amount) {
            var penalty =
              "$" +
              numeral(this.props.active_cancellation_rule.amount / 100).format(
                "0" +
                  ($("#delimiter").val() || ",") +
                  "0" +
                  ($("#separator").val() || ".") +
                  "00"
              );
          }
          return this.renderConfirmation(
            I18n.t("standard_cancellation_until", {
              days: this.props.active_cancellation_rule.time_value,
              penalty: penalty,
            }),
            I18n.t("cancel_this_room"),
            this.onCancel
          );
        } else {
          return this.renderCannotCancel();
        }
      }
    }
  }

  renderCannotCancel() {
    return (
      <div className="alert alert-danger text-center">
        {I18n.t("cannot_cancel_reservation")}
      </div>
    );
  }

  renderConfirmation(explanationText, btnText, btnOnClick) {
    return (
      <div className="alert alert-warning">
        <h4 className="text-center">
          {I18n.t("are_you_sure_you_want_to_cancel_this_reservation_segment", {
            room_name: this.state.reservation_segment.room_type.name,
            guests: this.props.guests_str,
            start_date: DateHelper.printDateToScreen(
              this.state.reservation_segment.check_in_date,
              this.props.date_format
            ),
            end_date: DateHelper.printDateToScreen(
              this.state.reservation_segment.check_out_date,
              this.props.date_format
            ),
          })}
        </h4>
        <p
          className="text-center"
          dangerouslySetInnerHTML={{ __html: explanationText }}
        ></p>
        <p className="text-center">
          <button type="button" className="btn btn-danger" onClick={btnOnClick}>
            {btnText}
          </button>
        </p>
        <p className="text-center cancel-link">
          <a href="#" data-dismiss="modal">
            {I18n.t("nevermind_i_dont_want_to_cancel")}
          </a>
        </p>
      </div>
    );
  }

  renderFullyRefundable() {
    var billing_policy = this.state.billing_policy;

    return this.renderConfirmation(
      I18n.t("refundable_until_str", {
        days:
          typeof billing_policy.refundable_until_days !== "undefined"
            ? billing_policy.refundable_until_days
            : "",
        time: billing_policy.refundable_until_time
          ? billing_policy.refundable_until_time.replace(" ", "&nbsp;")
          : "",
      }),
      I18n.t("cancel_this_room"),
      this.onCancel
    );
  }

  renderErrors() {
    if (this.state.errors && this.state.errors.length > 0) {
      var errors = this.state.errors.map((error) => {
        return <li key={error}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderSuccess() {
    if (this.state.success) {
      return (
        <div
          className="alert alert-success text-center"
          style={{ maxWidth: "444px", margin: "5px auto" }}
        >
          {this.state.success}
        </div>
      );
    }
  }

  /**
   * Change handlers
   */

  onCancel() {
    var self = this;

    this.setState({ loading: true });
    let folio_items = this.props.folio_items.map((folioItem) =>
      JSON.stringify(folioItem)
    );

    $.ajax({
      url: this.props.cancel_path,
      type: "POST",
      data: {
        reservation_segment_id: this.state.reservation_segment.id,
        folio_items: folio_items,
      },
    }).done(function (data) {
      self.setState({
        loading: false,
        errors: data.errors || null,
        success: data.success || null,
        cancelled: data.success ? true : false,
      });
      window.refresh_data();
    });
  }

  /**
   * Helper functions
   */

  getRefundableUntilDate() {
    var refundable_until_days = this.state.billing_policy.refundable_until_days;
    var refundable_until_time = this.state.billing_policy.refundable_until_time;
    var refundable_until_date = subDays(
      DateHelper.parseDateFromBackend(
        this.state.reservation_segment.check_in_date
      ),
      refundable_until_days
    );
    
    // We are not recording time on billing policy records, this is all nil and breaks 
    // var hours = parseInt(refundable_until_time.split(":")[0]);
    // if (refundable_until_time.indexOf("AM") !== -1) {
    //   refundable_until_date.set("hour", hours);
    // } else {
    //   
    //   refundable_until_date.set("hour", hours === 12 ? hours : hours + 12);
    // }

    // refundable_until_date.set(
    //   "minute",
    //   refundable_until_time.split(":")[1].split(" ")[0]
    // );

    return refundable_until_date;
  }
}

export default PortalReservationCancel;
